import React from "react";
import { motion } from "framer-motion";

const chapters = [
  {
    number: "01",
    title: "Presence",
    desc: "Showing up fully, without judgment, to understand your unique lived experience. Every session begins by making room for what is actually here.",
  },
  {
    number: "02",
    title: "Attunement",
    desc: "Listening beyond the words — for the emotional current underneath. We move at the pace of your nervous system, not the clock on the wall.",
  },
  {
    number: "03",
    title: "Transformation",
    desc: "Guiding you from feeling stuck to discovering actionable, sustainable paths toward healing — grounded in evidence and shaped to your life.",
  },
];

const ease = [0.16, 1, 0.3, 1];

export default function Manifesto() {
  return (
    <section
      id="approach"
      data-testid="manifesto"
      className="relative w-full py-28 sm:py-40"
    >
      <div className="mx-auto max-w-[1440px] px-6 sm:px-10">
        {/* Overline row */}
        <div className="flex items-baseline justify-between border-b border-[#D5D1C9] pb-6">
          <span className="font-sans-ui text-[11px] uppercase tracking-[0.3em] text-[#5C5C59]">
            (Ch. I) — The approach
          </span>
          <span className="font-serif-display italic text-[#5C5C59]">manifesto</span>
        </div>

        {/* Big statement */}
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-15%" }}
          transition={{ duration: 1, ease }}
          className="mt-14 font-serif-display font-light tracking-tighter leading-[0.98] text-5xl sm:text-6xl lg:text-7xl max-w-[16ch]"
        >
          Therapy is not a repair —{" "}
          <em className="italic text-[#2C4C3B]">it is a return.</em>
        </motion.h2>

        {/* Chapters grid */}
        <div className="mt-24 grid grid-cols-12 gap-x-6 gap-y-16">
          {chapters.map((c, i) => (
            <motion.article
              key={c.number}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{ duration: 0.9, delay: i * 0.1, ease }}
              className="col-span-12 md:col-span-4 relative pl-6 md:pl-8 border-l border-[#D5D1C9] group"
              data-testid={`manifesto-chapter-${c.number}`}
            >
              <div className="flex items-center justify-between mb-8">
                <span className="font-serif-display italic text-[#2C4C3B] text-6xl leading-none">
                  {c.number}
                </span>
                <span className="font-sans-ui text-[10px] uppercase tracking-[0.3em] text-[#5C5C59]">
                  Ch. {c.number}
                </span>
              </div>
              <h3 className="font-serif-display text-3xl sm:text-4xl tracking-tight text-[#1A1A18]">
                {c.title}
              </h3>
              <p className="mt-5 font-sans-ui text-[15px] leading-relaxed text-[#5C5C59] max-w-[36ch]">
                {c.desc}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
